import { aqoraClient } from '~/services/api/aqora-client';

export const linkDevicePeripheralOptions = (deviceName: string) =>
  aqoraClient.linkDevicePeripheralOptions({
    deviceName,
  });
